import { UseUserMediaProps, useUserMedia } from "@/utils";
import { FC, PropsWithChildren } from "react";
import { UserMediaContext } from "./UserMediaContext";

export const UserMediaProvider: FC<PropsWithChildren<UseUserMediaProps>> = ({ children, constraints }) => {
  const val = useUserMedia({ constraints });
  return <UserMediaContext.Provider value={val}>{children}</UserMediaContext.Provider>;
};
